import FigureDetail from "./FigureDetail";

export default FigureDetail;